<!-- <app-survay-header></app-survay-header> -->
<div class="Main-Cont">
    <div class="Ques-Cont">
        <div id="focus-row" style="visibility: hidden;"></div>
        <div class="text-dark fs-5 fw-bold">
            <!-- What is your Gender&#63; -->
            {{qService.currentQuestion.question_text}}
        </div>
        <div class="text-muted fs-6 fw-normal mt-2">
            You can choose only one answer
        </div>
        <div [ngClass]="qService.currentQuestion.options.length>9?'multiple-choice-select-Cont':'single-radio-select-Cont'"
            [ngStyle]="{'grid-template-columns':'repeat('+qService.questionView.colSpan+', 1fr)'}">
            <ng-container *ngIf="!qService.questionView.isImgOption">
                <ng-container *ngFor="let Ques of qService.currentQuestion.options ;let i=index">
                    <div class="single-radio-select-div" *ngIf="!qService.questionView.isImgOption">
                        <input 
                            type="checkbox" 
                            class="multiple-choice-single-input"  
                            name='multiple-choice-single'
                            [value]="Ques.text"
                            [checked]="checkedElement(Ques)"
                            (change)="multiOptionsSwitch(Ques)" 
                        />
                        <div class="text-white multiple-choice-single-label" (click)="multiOptionsSwitch(Ques)">
                           {{Ques.text}}
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="qService.questionView.isImgOption">
                <ng-container *ngFor="let Ques of slicedTabOption.options ;let i=index">
                    <div class="single-radio-select-div option-box" (click)="multiOptionsSwitch(Ques)" *ngIf="qService.questionView.isImgOption">
                        <input 
                            type="checkbox" 
                            class="option-box-input"  
                            name='multiple-choice-single'
                            [value]="Ques.text"
                            [checked]="checkedElement(Ques)"
                        />
                        <div class="option-holder">
                            <img class="option-img" [src]="'../../../../../assets/image/'+Ques.img_url">
                            <div class="fs-6 fw-bold" >
                               {{Ques.text}}
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
    <div class="footer">
        <div class="text-dark fw-bold fs-4  text-end">Q{{qService.currentQuestion.ques_index}}</div>
        <div class="text-end">
            <button class="btn btn-primary" (click)="next()" *ngIf="!isSwitchTab">Next</button>
            <button class="btn btn-primary" (click)="getSlicedOption()" *ngIf="isSwitchTab">Next</button>
        </div>
    </div>
</div>